export default __webpack_public_path__ + "static/media/Design-Img.208ef501.gif";